import React from 'react';
import TabGeneralDetails from '../TabGeneralDetails';
import TabInspectionsByCustomer from '../TabInspectionsByCustomer';
import TabDocuments from '../TabDocuments';
import TabCustomerFiles from '../TabCustomerFiles';
import {useCustomerDetailsUIContext} from '../CustomerDetailsUIContext';
import VerticalTabs from '../../../_common/components/VerticalTabs';
import EditPanel from '../EditPanel';

export function SectionsContainer() {
  const {
    greenInvoiceClientID, greenInvoiceApiKey, greenInvoiceSecret,
  } = useCustomerDetailsUIContext();
  const isDisabled = !(Boolean(greenInvoiceApiKey) && Boolean(greenInvoiceSecret) && Boolean(greenInvoiceClientID));

  return (
      <VerticalTabs
        headerContent={<EditPanel/>}
        tabs={[
          {
            id: 'general',
            label: 'כללי',
            icon: '/media/common/User.svg',
            content: <TabGeneralDetails/>,
          },
          {
            id: 'inspections',
            label: 'דוחות',
            icon: '/media/common/Clipboard.svg',
            content: <TabInspectionsByCustomer/>,
          },
          {
            id: 'payments',
            label: 'תשלומים',
            icon: '/media/common/GI-logo_black.svg',
            content: <TabDocuments/>,
            disabled: isDisabled
          },
          {
            id: 'documents',
            label: 'מסמכים כלליים',
            icon: '/media/common/File-plus.svg',
            content: <TabCustomerFiles/>,
          },
        ]}
      />
    );
}

export default SectionsContainer;
